import { UnauthorizedElementModel } from "@courses-pm2/api/src/ts/models";
import { Engine } from "@courses-pm2/api/src/ts/utils";

/**
 * Helper that parses <Placeholder /> elements in the response from the pm2
 * backend.
 */
export function parsePlaceholder({ node, portalId, engine }: {
    node: Element;
    portalId: string;
    engine?: Engine;
}): UnauthorizedElementModel {
    // Announce that a model has been identified if possible
    if (engine) {
        engine.announce(UnauthorizedElementModel);
    }

    // Extract basic data about the placeholder
    const accessCode = parseInt(node.getAttribute("access") || "0", 10);

    const elementType = String(node.getAttribute("type"))
        .toLowerCase();

    // Create a new instance of an UnauthorizedElementModel to represent this
    // placeholder
    return new UnauthorizedElementModel({
        isScrambled: false,
        accessCode,
        elementType,
        engine,
        portalId,
    });
}
